<ng-container #dynamicComponentContainer></ng-container>

<main>
    <router-outlet></router-outlet>
</main>